import { FC } from 'react';

import CapitalDecreaseModalHeader from './components/CapitalDecreaseModalHeader';
import CapitalDecreaseModalFooter from './components/CapitalDecreaseModalFooter';
import CapitalDecreaseModalBody from './components/CapitalDecreaseModalBody';
import CustomLoading from '../../CustomLoading';

import { useCapitalDecreaseModal } from './context/CapitalDecreaseModalContext';

import '../Modals.scss';

const CapitalDecreaseModal: FC = () => {
  const { data } = useCapitalDecreaseModal();

  return (
    <>
      <CapitalDecreaseModalHeader />
      <CapitalDecreaseModalBody />
      <CapitalDecreaseModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default CapitalDecreaseModal;
